/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NewAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NewAction({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/NewAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentsTabValueData = fromData.useDataValue({ viewPath,
context: 'appointments',
path: 'tab',
})
let constantData = 'upcoming'
let aggregateData = fromAggregate.equals(appointmentsTabValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}